import type { ReactNode } from "react";

/** The dashboard's pop-up (the Edit user shape): a dimmed page, a card in the middle, closed by Cancel
 *  or a click outside it. */
export function Modal({ onClose, wide = false, children }: { onClose: () => void; wide?: boolean; children: ReactNode }) {
  return (
    <div className="fixed inset-0 z-50 bg-black/60 overflow-y-auto p-3 sm:p-8 flex items-start justify-center"
      onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className={"w-full rounded-xl border border-border bg-surface shadow-xl mt-8 " + (wide ? "max-w-[680px]" : "max-w-[560px]")}>
        {children}
      </div>
    </div>
  );
}
